import React, { useState } from "react";
import FilterShell from "./FilterShell";
import useSpotsOptions from "./useSpotsOptions";

const defaultState = {
  status: "",
  startDate: "",
  endDate: "",
  spotId: "",
};

const STATUS_OPTIONS = [
  "pending",
  "succeeded",
  "failed",
  "cancelled",
  "refunded",
];

// admin: when true, render the Spot dropdown (only the admin payments
// view scopes by spot). The User Payments page doesn't pass this prop so
// nothing changes there.
// initial: seed the form from the parent's current filter state so the
// previously-picked values stay visible when the user reopens the popover.
const PaymentsFilters = ({ onApply, admin = false, initial = null }) => {
  const [data, setData] = useState({ ...defaultState, ...(initial || {}) });
  const spots = useSpotsOptions(admin);

  const onChange = (e) =>
    setData((d) => ({ ...d, [e.target.name]: e.target.value }));

  return (
    <FilterShell
      onApply={() => onApply(data)}
      onClear={() => {
        setData(defaultState);
        onApply(defaultState);
      }}
    >
      <div className={admin ? "col-md-6" : "col-md-4"}>
        <label className="form-label">Status</label>
        <select
          name="status"
          className="form-control"
          value={data.status}
          onChange={onChange}
        >
          <option value="">All</option>
          {STATUS_OPTIONS.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
      {admin && (
        <div className="col-md-6">
          <label className="form-label">Spot</label>
          <select
            name="spotId"
            className="form-control"
            value={data.spotId}
            onChange={onChange}
          >
            <option value="">All spots</option>
            {spots.map((s) => (
              <option key={s.id} value={s.id}>
                {s.label}
              </option>
            ))}
          </select>
        </div>
      )}
      <div className={admin ? "col-md-6" : "col-md-4"}>
        <label className="form-label">From</label>
        <input
          type="date"
          name="startDate"
          className="form-control"
          value={data.startDate}
          onChange={onChange}
        />
      </div>
      <div className={admin ? "col-md-6" : "col-md-4"}>
        <label className="form-label">To</label>
        <input
          type="date"
          name="endDate"
          className="form-control"
          value={data.endDate}
          onChange={onChange}
        />
      </div>
    </FilterShell>
  );
};

export default PaymentsFilters;
